import { jsx } from "panel";
import { SupportWidgetFormEl } from "common/widgets/chrome/chrome-header/support-widget/support-widget-form";
import { ModalEl } from "common/components/modal";
export function template() {
  const {
    isMaximized
  } = this.state;
  const formEl = /* @__PURE__ */ jsx(SupportWidgetFormEl, { attrs: this.helpers.getFormAttributes(), on: {
    close: this.helpers.handleSupportWidgetClosed,
    dock: this.helpers.handleSupportWidgetUnmaximized,
    maximize: this.helpers.handleSupportWidgetMaximized,
    "state-change": this.helpers.handleFormStateChange
  } });
  return /* @__PURE__ */ jsx("div", { sel: ".support-widget-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ModalEl, { attrs: {
    closeable: false,
    "grow-to-content": true,
    "hide-close-button": true,
    open: isMaximized,
    "style-override": ".mp-modal-main { background: none !important; box-shadow: none !important; }"
  }, "data-sentry-element": "ModalEl", "data-sentry-source-file": "template.tsx" }, isMaximized ? formEl : null), !isMaximized ? formEl : null);
}
